import React, { useState } from "react";
import { useMatch, useLocation } from "react-router-dom";
import Switch from "../Switch";
import { Alert, Badge, Col, Container, Row } from "reactstrap";
import CelebrityList from "./CelebrityList";
import { Main } from "../Layout";

const Celebrities = ({ celebrities }) => {
  const match = useMatch("/shop/categories/:category");

  const location = useLocation();
  const [isEuro, setIsEuro] = useState(
    location.state?.currency === "euro"
      ? true
      : location.state?.currency !== "cfa"
  );
  const celebritiesByCategory = celebrities.filter(
    (c) => c.category.slug === match.params.category
  );

  return (
    <div className={"my-3 my-lg-3"}>
      <Main fluid>
        <Row>
          <Col>
            <Switch
              state={isEuro}
              setState={setIsEuro}
              trueLabel={"EURO"}
              falseLabel={"CFA"}
            />
          </Col>
        </Row>
        <h1 className={"fs-4"}>
          Toutes nos célébrités dans la catégorie{" "}
          <Badge color="primary" pill>
            {match.params.category}
          </Badge>
        </h1>
      </Main>

      <CelebrityList celebrities={celebritiesByCategory} isEuro={isEuro} />
    </div>
  );
};

export default Celebrities;
